// extracted by mini-css-extract-plugin
export default {"tabs":"tabSelectorControl_tabs__Lg4xv","tab":"tabSelectorControl_tab__htEcG","disabledTab":"tabSelectorControl_disabledTab__adG8k","selected":"tabSelectorControl_selected__amw7p"};